// extracted by mini-css-extract-plugin
export default {"root":"RefundList_root__1VT-g","root_nothing":"RefundList_root_nothing__QIwn8"};